import React from "react";
import { companyInfo } from "@/mock";

const getHotlines = () => (
  companyInfo.hotlines?.length
    ? companyInfo.hotlines
    : [companyInfo.hotline, companyInfo.secondaryHotline]
).filter(Boolean);

const formatTelHref = (value = "") => `tel:${value.replace(/\s+/g, "")}`;

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unhandled error captured:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      const hotlines = getHotlines();
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4 text-center">
          <div className="max-w-md space-y-4">
            <p className="text-sm uppercase tracking-[0.2em] text-cyan-600 font-semibold">Đã xảy ra lỗi</p>
            <h1 className="text-3xl font-bold text-slate-900">
              Xin lỗi, chúng tôi đang gặp sự cố
            </h1>
            <p className="text-slate-600">
              Đội ngũ của {companyInfo.brandName} đã nhận được thông báo và sẽ khắc phục sớm nhất.
            </p>
            <div className="flex flex-col gap-3">
              <button
                type="button"
                onClick={this.handleReset}
                className="bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-3 rounded-lg font-semibold transition-colors"
              >
                Tải lại trang
              </button>
              <div className="flex flex-col gap-2">
                {hotlines.map((phone) => (
                  <a
                    key={phone}
                    href={formatTelHref(phone)}
                    className="text-cyan-600 hover:text-cyan-700 font-medium"
                  >
                    Liên hệ {phone}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
